var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"logo"},[_vm._v("Amazeballs")]),_vm._v(" "),(!_vm.store.currentUser)?_c('Login'):_c('div',[_c('button',{on:{"click":_vm.logout}},[_vm._v("Log out")]),_vm._v(" "),_c('InputForm'),_vm._v(" "),_c('BallsFeed')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d45ccd4e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 121
// module chunks = 0